import * as React from "react";

export function Row({ children }: React.PropsWithChildren) {
    return <div className="mc-row">{children}</div>;
}